const COOKIE_LOCALSTORAGE = false

export { COOKIE_LOCALSTORAGE }
